import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const TransectionDetails = ({ TransectionDetail, setTransectionData, transectionData, calculateDaysBetween, handleSDRefund }) => {
    const { currencyPrecision } = useCurrency();
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        if (name === "vacatingDate") {
            let startDate = TransectionDetail?.Lease_Date
            let vocatingDate = TransectionDetail?.Lease_Expiry
            const daysstayed = calculateDaysBetween(startDate, value);
            const rentDays = calculateDaysBetween(startDate, vocatingDate);
            let TotalDedcution = transectionData?.totalDeduction || 0
            let securityDep = transectionData?.securityDeposit || 0
            let totalAmountrec = transectionData?.totalAmountRec || 0
            let rentPerDay = (transectionData?.totalAmount / rentDays)
            let rentperStayedPeriod = (rentPerDay * daysstayed)
            let AmountBalance = (rentperStayedPeriod - totalAmountrec)
            setTransectionData((prev) => ({
                ...prev,
                totalAmountRec: totalAmountrec,
                dayesStayed: daysstayed,
                AmountBalance: AmountBalance?.toFixed(currencyPrecision?.decimalNumbers || 2),
                rentperStayedPeriod: rentperStayedPeriod?.toFixed(currencyPrecision?.decimalNumbers || 2),
                rentPerDay: rentPerDay?.toFixed(currencyPrecision?.decimalNumbers || 2),
                vacatingDate: value,
            }));
            handleSDRefund(securityDep, TotalDedcution, AmountBalance)

        } else {
            setTransectionData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    }
    const handleInputChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        if (name === "stayedPeriod") {
            let amtreceived = parseInt(transectionData?.totalAmountRec)
            let amtBalance = (value - amtreceived)
            setTransectionData((prev) => ({
                ...prev,
                rentperStayedPeriod: value,
                AmountBalance: amtBalance || 0
            }));

            let TotalDedcution = 0
            handleSDRefund(TransectionDetail?.SecurityDeposit, TotalDedcution, amtBalance)
        } else {
            setTransectionData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    }

    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(370px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.transDate}
                            onChange={(date) => handleDateChange({ name: 'transDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent For <br />The Period</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.rentPerPeriod} name="rentPerPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.securityDeposit} name="securityDeposit" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Notice Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.NoticeDate}
                            onChange={(date) => handleDateChange({ name: 'NoticeDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent For Stayed Periods</label>
                        <input type="text" className="p-2 form-control w-75" placeholder='0.000' value={transectionData?.rentperStayedPeriod} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Deductions</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalDeduction} name="totalDeduction" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Vacating Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.vacatingDate}
                            onChange={(date) => handleDateChange({ name: 'vacatingDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Amount Rec</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalAmountRec} />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">SD Refund</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.securityDeposit} name="sdRefund" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 w-25 start">Date Paid on {"  "} Vacation</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.vacationDate}
                            onChange={(date) => handleDateChange({ name: 'vacationDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent Amount  Balance</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.AmountBalance} name="rentAmtBalance" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="text-danger w-25 pt-1 start">Total Payable</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalpayable} name="rentAmtBalance" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">keys Return Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.returnDate}
                            onChange={(date) => handleDateChange({ name: 'returnDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label w-25 pt-1 start">Total Deduction</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.deductionTotal} name="rentAmtBalance" />
                    </div>
                    <div className='d-flex'>
                        <label htmlFor="validationCustom01" className="form-label mt-3 w-50 start">Days Stayed</label>
                        <label htmlFor="validationCustom01" className="form-label w-50  mt-3 start">Actual Rent For Stayed Periods</label>
                    </div>
                    <div></div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label w-25 pt-1 start">Rent {transectionData?.AmountBalance > 0 ? "Ba lance" : "Refund"}</label>
                        <input type="text" className="p-2 form-control w-75"
                            value={Math.abs(transectionData?.AmountBalance ?? 0)}
                            name="rentAmtBalance" />
                    </div>
                    <div className='d-flex gap-3'>
                        <div className="w-50">
                            <input type="text" className="p-2 form-control" value={transectionData?.dayesStayed || "0"} />
                        </div>
                        <div className="w-50">
                            <input type="text" className="p-2 form-control" value={transectionData?.rentPeriodUnchange || "0.000"} />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Vacating Reason</label>
                        <textarea type="text" className="p-2 form-control " name="reason" onChange={handleInputChange} />
                    </div>
                    <div>
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks / Comments</label>
                        <textarea type="text" className="p-2 form-control " name="remarks" onChange={handleInputChange} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TransectionDetails;